import { render, staticRenderFns } from "./integralJL.vue?vue&type=template&id=c85a6942&scoped=true&"
import script from "./integralJL.vue?vue&type=script&lang=js&"
export * from "./integralJL.vue?vue&type=script&lang=js&"
import style0 from "./integralJL.vue?vue&type=style&index=0&id=c85a6942&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85a6942",
  null
  
)

export default component.exports